import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  chatService,
  CreateInternalChannelDto,
  UpdateInternalChannelDto,
} from "@/services/chat-service";

export const useCreateChannelWithGuest = () => {
  return useMutation({
    mutationFn: (bookingId: string) => chatService.createChannel({ bookingId }),
  });
};

export const useCreateInternalChannel = () => {
  return useMutation({
    mutationFn: (dto: CreateInternalChannelDto) =>
      chatService.createInternalChannel(dto),
  });
};

export const useUpdateInternalChannel = () => {
  return useMutation({
    mutationFn: ({ id, dto }: { id: string; dto: UpdateInternalChannelDto }) =>
      chatService.updateInternalChannel(id, dto),
  });
};

export const useDeleteInternalChannel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => chatService.deleteInternalChannel(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["channels"] });
    },
  });
};
